import React from 'react';
import {Box, SxProps, Theme} from '@mui/material';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    sx?: SxProps<Theme>;
}

const CustomTabPanel: React.FC<TabPanelProps> = (props) => {
    const {children, value, index, sx} = props;

    const defaultSx: SxProps<Theme> = {p: {xs: 1, md: 3}};

    return value === index ? (
        <Box sx={sx || defaultSx}>
            {children}
        </Box>
    ) : null;
};

export default CustomTabPanel;
